var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetailFilledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 12.8334C10.2217 12.8334 12.8333 10.2217 12.8333 7.00002C12.8333 3.77836 10.2217 1.16669 6.99999 1.16669C3.77833 1.16669 1.16666 3.77836 1.16666 7.00002C1.16666 10.2217 3.77833 12.8334 6.99999 12.8334Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 9.91665C5.73516 8.49203 8.2502 8.42495 9.625 9.91665M8.45547 5.54165C8.45547 6.34705 7.80162 6.99998 6.99504 6.99998C6.18852 6.99998 5.53465 6.34705 5.53465 5.54165C5.53465 4.73623 6.18852 4.08331 6.99504 4.08331C7.80162 4.08331 8.45547 4.73623 8.45547 5.54165Z",
    stroke: "black",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailFilledIcon);
export default __webpack_public_path__ + "static/media/retailFilledIcon.b7b1cc7166e8ecfa89eac127a62dea33.svg";
export { ForwardRef as ReactComponent };